import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { addToSetlist, createSetlist, mySetlists, type Setlist } from "../lib/setlists";
import { supabase } from "../lib/supabase";

/** Adding a song to a list is the one action people take mid-browse, so it is a
 *  popover on the song page rather than a trip to another screen. */
export function AddToSetlist({ songId }: { songId: string }) {
  const [open, setOpen] = useState(false);
  const [lists, setLists] = useState<Setlist[] | null>(null);
  const [added, setAdded] = useState<string | null>(null);
  const [signedIn, setSignedIn] = useState(false);

  useEffect(() => {
    supabase.auth.getUser().then(({ data }) => setSignedIn(Boolean(data.user)));
  }, []);

  useEffect(() => { if (open && !lists) mySetlists().then(setLists); }, [open, lists]);

  if (!signedIn) {
    return <Link className="btn" to="/signin">Sign in to save</Link>;
  }

  async function add(list: Setlist) {
    await addToSetlist(list.id, songId);
    setAdded(list.name);
    setOpen(false);
  }

  async function createAndAdd() {
    const name = prompt("Name the setlist");
    if (!name?.trim()) return;
    const created = await createSetlist(name.trim());
    if (created) await add(created);
  }

  return (
    <span className="add-wrap">
      <button className="btn" onClick={() => setOpen(!open)}>
        {added ? `Added to ${added}` : "Add to setlist"}
      </button>
      {open && (
        <div className="popover card">
          {lists?.length ? lists.map((list) => (
            <button key={list.id} className="popover-row" onClick={() => add(list)}>
              {list.name}
            </button>
          )) : <span className="muted small">No setlists yet.</span>}
          <button className="popover-row new" onClick={createAndAdd}>+ New setlist</button>
        </div>
      )}
    </span>
  );
}
